import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, Shield } from "lucide-react";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    (window as any).gtag?.('consent', 'update', { ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted', analytics_storage: 'granted' });
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie-consent", "declined");
    (window as any).gtag?.('consent', 'update', { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Blur overlay behind everything */}
      <div className="fixed inset-0 z-[59] bg-black/40 backdrop-blur-md animate-fade-in" />

      {/* Cookie banner */}
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 animate-fade-in">
        <div className="max-w-lg w-full rounded-2xl bg-charcoal border border-white/10 shadow-2xl p-6 md:p-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-full bg-white/10">
              <Cookie className="w-5 h-5 text-white/80" />
            </div>
            <h2 className="text-white font-serif text-lg">Cookie-Einstellungen</h2>
          </div>

          <p className="text-sm text-white/70 leading-relaxed mb-2">
            Wir verwenden <strong className="text-white/90">ausschließlich technisch notwendige Cookies</strong>, die für den Betrieb der Website erforderlich sind. Diese Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website notwendig.
          </p>
          <p className="text-sm text-white/70 leading-relaxed mb-2">
            Darüber hinaus nutzen wir <strong className="text-white/90">Google Ads Conversion-Tracking</strong> zur Messung von Werbeerfolgen. Dabei werden Daten an Google übermittelt.
          </p>
          <p className="text-xs text-white/50 mb-5">
            Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) und Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).{" "}
            <Link to="/nuernberg/datenschutz" className="text-highlight hover:underline">
              Datenschutzerklärung
            </Link>
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={accept}
              className="flex-1 px-5 py-2.5 rounded-xl bg-white text-charcoal text-sm font-semibold hover:bg-white/90 transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
            >
              Alle akzeptieren
            </button>
            <button
              onClick={decline}
              className="flex-1 px-5 py-2.5 rounded-xl bg-white/10 text-white/80 text-sm font-medium border border-white/10 hover:bg-white/20 transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
            >
              Nur notwendige
            </button>
          </div>

          <div className="flex items-center justify-center gap-1.5 mt-4 text-white/30">
            <Shield className="w-3 h-3" />
            <span className="text-[10px]">DSGVO-konform</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieBanner;
